<template>
  <b-modal
    ref="modalMultipleReiseterminBearbeiten"
    id="modalMultipleReiseterminBearbeiten"
    size="xl"
    :title="title"
    @show="onShow"
    @hide="onHide"
    centered
    class="m-0 p-0"
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-overlay :show="isLoading">
      <div v-if="isReisemetadata">
        Felder, die für (zukünftige) Reisetermine der Saison übernommen werden, auswählen:
      </div>
      <div v-else>Felder zum Bearbeiten auswählen:</div>
      <div class="d-flex align-items-center mt-2" style="gap: 8px">
        <AppSelect
          v-model="editFields"
          :options="fieldEditSelectOptions"
          label="Felder"
          placeholder="Bitte Optionen wählen"
          search-placeholder="Feld suchen …"
          multiple
          clearable
          class="w-75"
        />
      </div>
      <div class="mt-4 grid">
        <b-form-group label="Overnight Outbound" v-if="labelsFromEditFields.includes('Overnight Outbound')">
          <AppSelect
            v-model="$v.form.overnightOutbound.$model"
            sort="none"
            :options="overnightOptions"
            label="Overnight Outbound"
            placeholder="-"
            hide-search
          />
        </b-form-group>
        <b-form-group label="Overnight Inbound" v-if="labelsFromEditFields.includes('Overnight Inbound')">
          <AppSelect
            v-model="$v.form.overnightInbound.$model"
            sort="none"
            :options="overnightOptions"
            label="Overnight Inbound"
            placeholder="-"
            hide-search
          />
        </b-form-group>
        <b-form-group label="Kalk Pax" v-if="labelsFromEditFields.includes('Kalk Pax')">
          <b-form-input
            size="sm"
            v-model="$v.form.kalkPax.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Min Pax" v-if="labelsFromEditFields.includes('Min Pax')">
          <b-form-input
            size="sm"
            v-model="$v.form.minPax.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Max Pax" v-if="labelsFromEditFields.includes('Max Pax')">
          <b-form-input
            size="sm"
            v-model="$v.form.maxPax.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Durchführbare Min Pax"
          v-if="labelsFromEditFields.includes('Durchführbare Min Pax')"
        >
          <b-form-input
            size="sm"
            v-model="$v.form.durchfuehrbareMinPax.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Zielland Zielflughäfen"
          v-if="labelsFromEditFields.includes('Zielland Zielflughäfen')"
        >
          <AirportsSucheMultiselect
            v-model="$v.form.ziellandZielflughaefenIataCodes.$model"
            :isMultipleAllowed="true"
            :openDirection="'top'"
            :filterCountry="reiseterminEditData?.reiseterminkuerzel?.substring(0, 2)"
            id="abflughafen"
          ></AirportsSucheMultiselect>
        </b-form-group>
        <b-form-group
          label="Zielland Zielflughafen Priorität"
          v-if="labelsFromEditFields.includes('Zielland Zielflughafen Prio')"
        >
          <AppSelect
            v-model="$v.form.ziellandZielflughafenPrio.$model"
            sort="none"
            :options="$v.form.ziellandZielflughaefenIataCodes.$model"
            label="Zielland Zielflughafen Priorität"
            placeholder="-"
            hide-search
            clearable
          />
        </b-form-group>
        <b-form-group
          label="Zielland Abflughäfen"
          v-if="labelsFromEditFields.includes('Zielland Abflughäfen')"
        >
          <AirportsSucheMultiselect
            v-model="$v.form.ziellandAbflughaefenIataCodes.$model"
            :isMultipleAllowed="true"
            :openDirection="'top'"
            :filterCountry="reiseterminEditData?.reiseterminkuerzel?.substring(0, 2)"
            id="abflughafen"
          ></AirportsSucheMultiselect>
        </b-form-group>
        <b-form-group
          label="Zielland Abflughafen Priorität"
          v-if="labelsFromEditFields.includes('Zielland Abflughafen Prio')"
        >
          <AppSelect
            v-model="$v.form.ziellandAbflughafenPrio.$model"
            sort="none"
            :options="$v.form.ziellandAbflughaefenIataCodes.$model"
            label="Zielland Abflughafen Priorität"
            placeholder="-"
            hide-search
            clearable
          />
        </b-form-group>
        <b-form-group
          label="Erw. Termindurchführungsquote"
          v-if="labelsFromEditFields.includes('Erw. Termindurchführungsquote')"
        >
          <b-input-group size="sm">
            <b-form-input
              size="sm"
              v-model="$v.form.erwarteteTermindurchfuehrungsquote.$model"
              :number="true"
              type="number"
            ></b-form-input>
            <template #append>
              <b-input-group-text>%</b-input-group-text>
            </template>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="EK kalk. Vornacht DZ p.P."
          v-if="labelsFromEditFields.includes('EK kalk. Vornacht DZ p.P.')"
        >
          <b-input-group size="sm">
            <b-form-input
              size="sm"
              v-model="$v.form.einkaufspreisVornachtDzProPerson.$model"
              :number="true"
              type="number"
            ></b-form-input>
            <template #append>
              <b-input-group-text>€</b-input-group-text>
            </template>
          </b-input-group>
        </b-form-group>
        <b-form-group label="SKR Flugangebot" v-if="labelsFromEditFields.includes('SKR Flugangebot')">
          <b-input-group size="sm">
            <b-form-input
              size="sm"
              v-model="$v.form.skrFlugangebot.$model"
              :number="true"
              type="number"
            ></b-form-input>
            <template #append>
              <b-input-group-text>€</b-input-group-text>
            </template>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Vorverlängerung" v-if="labelsFromEditFields.includes('Vorverlängerung')">
          <b-input-group size="sm">
            <b-form-input
              size="sm"
              v-model="$v.form.vorverlaengerung.$model"
              :number="true"
              type="number"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="Transferszenario Hin"
          v-if="labelsFromEditFields.includes('Transferszenario Hin')"
        >
          <AppSelect
            v-model="$v.form.transferszenarioHin.$model"
            sort="none"
            :options="minimaltransferszenarioOptions"
            label="Transferszenario Hin"
            hide-search
          />
        </b-form-group>
        <b-form-group
          label="Transferszenario Rück"
          v-if="labelsFromEditFields.includes('Transferszenario Rück')"
        >
          <AppSelect
            v-model="$v.form.transferszenarioRueck.$model"
            sort="none"
            :options="minimaltransferszenarioOptions"
            label="Transferszenario Rück"
            hide-search
          />
        </b-form-group>
        <b-form-checkbox
          v-model="$v.form.hotelstartVorLandung.$model"
          class="align-self-center"
          v-if="labelsFromEditFields.includes('Hotelstart vor Landung')"
        >
          Hotelstart vor Landung
        </b-form-checkbox>
        <b-form-checkbox
          v-model="$v.form.rueckflugNachHotelende.$model"
          class="align-self-center"
          v-if="labelsFromEditFields.includes('Rückflug nach Hotelende')"
        >
          Rückflug nach Hotelende
        </b-form-checkbox>
        <b-form-checkbox
          v-model="$v.form.vornachtMoeglich.$model"
          class="align-self-center"
          v-if="labelsFromEditFields.includes('Vornacht möglich')"
        >
          Vornacht möglich
        </b-form-checkbox>
        <b-form-group label="Hotelnächte" v-if="labelsFromEditFields.includes('Hotelnächte')">
          <b-form-input
            size="sm"
            v-model="$v.form.hotelnaechte.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Frühester Abflug" v-if="labelsFromEditFields.includes('Restriktionen Rückflug')">
          <DatePicker
            :lang="langConfig"
            type="time"
            class="w-100"
            v-model="$v.form.fruehesterAbflug.$model"
            :format="formatDatetimepicker"
            :show-second="false"
            value-type="format"
          ></DatePicker>
        </b-form-group>
        <b-form-group label="Spätester Abflug" v-if="labelsFromEditFields.includes('Restriktionen Rückflug')">
          <DatePicker
            :lang="langConfig"
            type="time"
            class="w-100"
            v-model="$v.form.spaetesterAbflug.$model"
            :format="formatDatetimepicker"
            :show-second="false"
            value-type="format"
          />
          <div class="d-flex align-items-center mt-3">
            <b-form-checkbox size="lg" v-model="$v.form.restriktionenRueckRollover.$model" :disabled="true" />
            <span class="ml-1" style="font-size: 14px">+1</span>
          </div>
        </b-form-group>
        <b-form-group label="Früheste Ankunft" v-if="labelsFromEditFields.includes('Restriktionen Hinflug')">
          <DatePicker
            :lang="langConfig"
            type="time"
            class="w-100"
            v-model="$v.form.fruehesteAnkunft.$model"
            :format="formatDatetimepicker"
            :show-second="false"
            value-type="format"
          ></DatePicker>
        </b-form-group>
        <b-form-group label="Späteste Ankunft" v-if="labelsFromEditFields.includes('Restriktionen Hinflug')">
          <DatePicker
            :lang="langConfig"
            type="time"
            class="w-100"
            v-model="$v.form.spaetesteAnkunft.$model"
            :format="formatDatetimepicker"
            :show-second="false"
            value-type="format"
          />
          <div class="d-flex align-items-center mt-3">
            <b-form-checkbox size="lg" v-model="$v.form.restriktionenHinRollover.$model" :disabled="true" />
            <span class="ml-1" style="font-size: 14px">+1</span>
          </div>
        </b-form-group>
        <b-form-group label="Releasefrist" v-if="labelsFromEditFields.includes('Releasefrist')">
          <AddRemoveButton v-if="form.releasefrist === null" @click="onAddReleasefrist" />
          <div v-else v-for="item in form.releasefrist" :key="'releasefrist-' + item.id">
            <b-form-group class="widthEditField">
              <template #label>
                <div class="d-flex align-items-center" style="gap: 4px">
                  <div>{{ `${item.id}. Releasefrist` }}</div>
                  <AddRemoveButton v-if="form.releasefrist?.length === item.id" @click="onAddReleasefrist" />
                  <AddRemoveButton
                    v-if="form.releasefrist?.length === item.id"
                    @click="onRemoveReleasefrist"
                    remove
                  />
                </div>
              </template>
              <b-form-input
                size="sm"
                v-model="item.value"
                :number="true"
                type="number"
                min="0"
                max="365"
                step="1"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </b-form-group>
        <b-form-checkbox
          v-model="$v.form.istZusatztermin.$model"
          class="align-self-center"
          v-if="labelsFromEditFields.includes('Zusatztermin')"
        >
          Zusatztermin
        </b-form-checkbox>

        <b-form-checkbox
          v-model="$v.form.istInKlaerung.$model"
          class="align-self-center"
          v-if="labelsFromEditFields.includes('In Klärung')"
        >
          In Klärung
        </b-form-checkbox>

        <b-form-group label="TH Inlandsflug" v-if="labelsFromEditFields.includes('TH Inlandsflug')">
          <b-form-input
            size="sm"
            v-model="$v.form.thInlandsflug.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="TH Langstrecke" v-if="labelsFromEditFields.includes('TH Langstrecke')">
          <b-form-input
            size="sm"
            v-model="$v.form.thLangstrecke.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Max. Wartezeit Hin" v-if="labelsFromEditFields.includes('Max. Wartezeit Hin')">
          <b-form-input
            size="sm"
            v-model="$v.form.hinflugMaxWartezeit.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Max. Wartezeit Rück" v-if="labelsFromEditFields.includes('Max. Wartezeit Rück')">
          <b-form-input
            size="sm"
            v-model="$v.form.rueckflugMaxWartezeit.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Max. Anzahl Transfergruppen Hin"
          v-if="labelsFromEditFields.includes('Max. Anzahl Transfergruppen Hin')"
        >
          <b-form-input
            size="sm"
            v-model="$v.form.hinflugMaxAnzahlTransfergruppen.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Max. Anzahl Transfergruppen Rück"
          v-if="labelsFromEditFields.includes('Max. Anzahl Transfergruppen Rück')"
        >
          <b-form-input
            size="sm"
            v-model="$v.form.rueckflugMaxAnzahlTransfergruppen.$model"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Weitere Partner"
          class="weitere-partner-feld"
          v-if="labelsFromEditFields.includes('Weitere Partner')"
        >
          <CountrymanagerSucheMultiselect
            v-model="$v.form.weiterePartner.$model"
            :isMultipleAllowed="true"
            placeholder="Weitere Partner suchen…"
          />
          <div class="hinweis-ueberschreiben mt-2">Achtung: Vorhandene Werte werden überschrieben.</div>
        </b-form-group>
      </div>
    </b-overlay>
    <template #modal-footer="{ hide }" class="pl-1">
      <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
      <b-button
        class="dialog-btn"
        variant="primary"
        :disabled="editFields.length === 0 || isLoading"
        @click="handleSubmit(hide)"
      >
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { validationMixin } from 'vuelidate';
import AirportsSucheMultiselect from '@/components/common/airports-suche-multiselect.vue';
import AppSelect from '@/components/common/app-select/app-select.vue';
import CountrymanagerSucheMultiselect from '@/components/common/countrymanager-suche-multiselect.vue';
import {
  EDIT_REISETERMIN_METADATA_MULTIPLE,
  BULK_EDIT_REISETERMIN_VALUES,
} from '@/core/produkte/reisetermine/stores/reiseterminplanung.module';
import { buildReiseterminMetadataParams } from '@/core/produkte/reisetermine/reisetermin-metadata-params';
import currenciesJson from '@/core/common/helpers/currencies.json';
import DatePicker from 'vue2-datepicker';
import {
  langConfig,
  minimaltransferszenarioOptions,
  arraysEqualUnordered,
} from '@/core/common/helpers/utils.js';
import AddRemoveButton from '@/components/common/add-remove-button.vue';

export default {
  mixins: [validationMixin],
  props: {
    reiseterminEditData: {
      type: Array,
      required: true,
    },
    preexistingFormData: { type: Object, default: null },
    changedFields: { type: Array },
    title: { type: String },
    isReisemetadata: { type: Boolean, default: false },
  },
  components: {
    AddRemoveButton,
    DatePicker,
    AirportsSucheMultiselect,
    AppSelect,
    CountrymanagerSucheMultiselect,
  },
  computed: {
    // Das Select arbeitet mit den Feldschlüsseln, angezeigt wird die Beschriftung
    fieldEditSelectOptions() {
      return this.fieldEditOptions.map(option => ({ value: option.key, text: option.label }));
    },
    // Die vollständigen Feldkonfigurationen zur aktuellen Auswahl
    selectedFieldOptions() {
      return (this.editFields ?? [])
        .map(key => this.fieldEditOptions.find(option => option.key === key))
        .filter(Boolean);
    },
    ziellandAbflughaefenIataCodes() {
      return this.form?.ziellandAbflughaefenIataCodes;
    },
    ziellandZielflughaefenIataCodes() {
      return this.form?.ziellandZielflughaefenIataCodes;
    },
    reisekuerzelToEdit() {
      if (
        this.reiseterminEditData?.length > 0 &&
        new Set(this.reiseterminEditData.map(r => r.reiseterminkuerzel.substring(0, 6))).size === 1
      ) {
        return this.reiseterminEditData[0].reiseterminkuerzel.substring(0, 6);
      }
      return '';
    },
    labelsFromEditFields() {
      return this.selectedFieldOptions.map(option => option.label);
    },
    keysFromEditFields() {
      return this.editFields ?? [];
    },
  },
  mounted() {
    this.currenciesOptions = Object.keys(currenciesJson);
  },
  watch: {
    ziellandAbflughaefenIataCodes: {
      handler(v) {
        if (v?.length > 0 && this.form.ziellandAbflughafenPrio === null) {
          this.form.ziellandAbflughafenPrio = v[0];
        }
        if (v?.length === 0) {
          this.form.ziellandAbflughafenPrio = null;
        }
        if (!v?.some(fh => fh.flughafenIataCode === this.form.ziellandAbflughafenPrio)) {
          if (v?.length > 0) {
            this.form.ziellandAbflughafenPrio = v[0];
          } else {
            this.form.ziellandAbflughafenPrio = null;
          }
        }
      },
    },
    ziellandZielflughaefenIataCodes: {
      handler(v) {
        if (v?.length > 0 && this.form.ziellandZielflughafenPrio === null) {
          this.form.ziellandZielflughafenPrio = v[0];
        }
        if (v?.length === 0) {
          this.form.ziellandZielflughafenPrio = null;
        }
        if (!v?.some(fh => fh.flughafenIataCode === this.form.ziellandZielflughafenPrio)) {
          if (v?.length > 0) {
            this.form.ziellandZielflughafenPrio = v[0];
          } else {
            this.form.ziellandZielflughafenPrio = null;
          }
        }
      },
    },
    form: {
      handler(v) {
        if (v.fruehesterAbflug != null && v.spaetesterAbflug != null) {
          const compareFruehesterAbflug = new Date().setHours(
            parseInt(v.fruehesterAbflug.substring(0, 2)),
            parseInt(v.fruehesterAbflug.substring(3, 5))
          );
          const compareSpaetesterAbflug = new Date().setHours(
            parseInt(v.spaetesterAbflug.substring(0, 2)),
            parseInt(v.spaetesterAbflug.substring(3, 5))
          );

          if (compareFruehesterAbflug >= compareSpaetesterAbflug) {
            this.form.restriktionenRueckRollover = true;
          } else {
            this.form.restriktionenRueckRollover = false;
          }
        } else {
          this.form.restriktionenRueckRollover = null;
        }

        if (v.fruehesteAnkunft != null && v.spaetesteAnkunft != null) {
          const compareFruehesteAnkunft = new Date().setHours(
            parseInt(v.fruehesteAnkunft.substring(0, 2)),
            parseInt(v.fruehesteAnkunft.substring(3, 5))
          );
          const compareSpaetesteAnkunft = new Date().setHours(
            parseInt(v.spaetesteAnkunft.substring(0, 2)),
            parseInt(v.spaetesteAnkunft.substring(3, 5))
          );

          if (compareFruehesteAnkunft >= compareSpaetesteAnkunft) {
            this.form.restriktionenHinRollover = true;
          } else {
            this.form.restriktionenHinRollover = false;
          }
        } else {
          this.form.restriktionenHinRollover = null;
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      langConfig,
      minimaltransferszenarioOptions,
      overnightOptions: [
        { value: null, text: '-' },
        { value: 0, text: '0' },
        { value: 1, text: '+1' },
        { value: 2, text: '+2' },
      ],
      wochentagOptions: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
      isLoading: false,
      currenciesOptions: null,
      editFields: [],
      fieldEditOptions: [
        { label: 'Overnight Outbound', key: 'overnightOutbound', reiseterminValues: false },
        { label: 'Overnight Inbound', key: 'overnightInbound', reiseterminValues: false },
        { label: 'Kalk Pax', key: 'kalkPax', reiseterminValues: false },
        { label: 'Min Pax', key: 'minPax', reiseterminValues: false },
        { label: 'Max Pax', key: 'maxPax', reiseterminValues: false },
        { label: 'Durchführbare Min Pax', key: 'durchfuehrbareMinPax', reiseterminValues: false },
        { label: 'Zielland Zielflughäfen', key: 'ziellandZielflughaefenIataCodes', reiseterminValues: false },
        { label: 'Zielland Zielflughafen Prio', key: 'ziellandZielflughafenPrio', reiseterminValues: false },
        { label: 'Zielland Abflughäfen', key: 'ziellandAbflughaefenIataCodes', reiseterminValues: false },
        { label: 'Zielland Abflughafen Prio', key: 'ziellandAbflughafenPrio', reiseterminValues: false },
        { label: 'SKR Flugangebot', key: 'skrFlugangebot', reiseterminValues: false },
        { label: 'Transferszenario Hin', key: 'transferszenarioHin', reiseterminValues: false },
        { label: 'Transferszenario Rück', key: 'transferszenarioRueck', reiseterminValues: false },
        { label: 'Hotelstart vor Landung', key: 'hotelstartVorLandung', reiseterminValues: false },
        { label: 'Rückflug nach Hotelende', key: 'rueckflugNachHotelende', reiseterminValues: false },
        { label: 'Vornacht möglich', key: 'vornachtMoeglich', reiseterminValues: false },
        { label: 'Hotelnächte', key: 'hotelnaechte', reiseterminValues: false },
        { label: 'Restriktionen Rückflug', key: 'restriktionenAbflug', reiseterminValues: false },
        { label: 'Restriktionen Hinflug', key: 'restriktionenAnkunft', reiseterminValues: false },
        { label: 'Releasefrist', key: 'releasefrist', reiseterminValues: false },
        { label: 'Zusatztermin', key: 'istZusatztermin', reiseterminValues: true },
        { label: 'TH Inlandsflug', key: 'thInlandsflug', reiseterminValues: true },
        { label: 'TH Langstrecke', key: 'thLangstrecke', reiseterminValues: true },
        { label: 'Vorverlängerung', key: 'vorverlaengerung', reiseterminValues: false },
        {
          label: 'Erw. Termindurchführungsquote',
          key: 'erwarteteTermindurchfuehrungsquote',
          reiseterminValues: false,
        },
        {
          label: 'EK kalk. Vornacht DZ p.P.',
          key: 'einkaufspreisVornachtDzProPerson',
          reiseterminValues: false,
        },
        {
          label: 'Max. Wartezeit Hin',
          key: 'hinflugMaxWartezeit',
          reiseterminValues: false,
        },
        {
          label: 'Max. Wartezeit Rück',
          key: 'rueckflugMaxWartezeit',
          reiseterminValues: false,
        },
        {
          label: 'Max. Anzahl Transfergruppen Hin',
          key: 'hinflugMaxAnzahlTransfergruppen',
          reiseterminValues: false,
        },
        {
          label: 'Max. Anzahl Transfergruppen Rück',
          key: 'rueckflugMaxAnzahlTransfergruppen',
          reiseterminValues: false,
        },
        { label: 'In Klärung', key: 'istInKlaerung', reiseterminValues: true },
        { label: 'Weitere Partner', key: 'weiterePartner', reiseterminValues: false },
      ],
      formatDatetimepicker: 'HH:mm',
      form: {
        overnightOutbound: null,
        overnightInbound: null,
        ziellandAbflughaefenIataCodes: null,
        ziellandZielflughaefenIataCodes: null,
        ziellandAbflughafenPrio: null,
        ziellandZielflughafenPrio: null,
        hotelstartVorLandung: null,
        rueckflugNachHotelende: null,
        vornachtMoeglich: false,
        kalkPax: null,
        minPax: null,
        maxPax: null,
        durchfuehrbareMinPax: null,
        skrFlugangebot: null,
        transferszenarioHin: null,
        transferszenarioRueck: null,
        hotelnaechte: null,
        fruehesterAbflug: null,
        spaetesterAbflug: null,
        fruehesteAnkunft: null,
        spaetesteAnkunft: null,
        releasefrist: null,
        istZusatztermin: null,
        istInKlaerung: null,
        thLangstrecke: null,
        thInlandsflug: null,
        einkaufspreisVornachtDzProPerson: null,
        erwarteteTermindurchfuehrungsquote: null,
        restriktionenHinRollover: null,
        restriktionenRueckRollover: null,
        vorverlaengerung: null,
        hinflugMaxWartezeit: null,
        hinflugMaxAnzahlTransfergruppen: null,
        rueckflugMaxWartezeit: null,
        rueckflugMaxAnzahlTransfergruppen: null,
        weiterePartner: [],
      },
    };
  },
  validations: {
    form: {
      overnightOutbound: {},
      overnightInbound: {},
      ziellandAbflughaefenIataCodes: {},
      ziellandZielflughaefenIataCodes: {},
      ziellandAbflughafenPrio: {},
      ziellandZielflughafenPrio: {},
      hotelstartVorLandung: {},
      rueckflugNachHotelende: {},
      vornachtMoeglich: {},
      kalkPax: {},
      minPax: {},
      maxPax: {},
      durchfuehrbareMinPax: {},
      skrFlugangebot: {},
      transferszenarioHin: {},
      transferszenarioRueck: {},
      hotelnaechte: {},
      fruehesterAbflug: {},
      spaetesterAbflug: {},
      fruehesteAnkunft: {},
      spaetesteAnkunft: {},
      releasefrist: {},
      istZusatztermin: {},
      istInKlaerung: {},
      thInlandsflug: {},
      thLangstrecke: {},
      einkaufspreisVornachtDzProPerson: {},
      erwarteteTermindurchfuehrungsquote: {},
      restriktionenHinRollover: {},
      restriktionenRueckRollover: {},
      vorverlaengerung: {},
      hinflugMaxWartezeit: {},
      hinflugMaxAnzahlTransfergruppen: {},
      rueckflugMaxWartezeit: {},
      rueckflugMaxAnzahlTransfergruppen: {},
      weiterePartner: {},
    },
  },
  methods: {
    formatParams() {
      if (this.editFields?.length > 0 && this.reiseterminEditData?.length > 0) {
        const bearbeitet = this.bearbeiteteMetadataParams();
        return this.reiseterminEditData.reduce((acc, curr) => {
          acc[curr.startdatum] = { ...buildReiseterminMetadataParams(curr.metadata), ...bearbeitet };
          return acc;
        }, {});
      } else return null;
    },
    // Liefert nur die ausgewählten Felder mit den Formularwerten, alle übrigen kommen aus dem Bestand des Termins
    bearbeiteteMetadataParams() {
      const keys = this.keysFromEditFields;
      const sonderfelder = ['restriktionenAbflug', 'restriktionenAnkunft', 'releasefrist'];
      const params = Object.fromEntries(
        this.selectedFieldOptions
          .filter(option => !option.reiseterminValues && !sonderfelder.includes(option.key))
          .map(option => [option.key, this.form[option.key]])
      );
      const mitSekunden = zeit => (zeit?.length >= 8 ? zeit : zeit + ':00');
      if (keys.includes('restriktionenAbflug')) {
        params.fruehesterAbflug = mitSekunden(this.form.fruehesterAbflug);
        params.spaetesterAbflug = mitSekunden(this.form.spaetesterAbflug);
        params.restriktionenRueckRollover = +this.form.restriktionenRueckRollover;
      }
      if (keys.includes('restriktionenAnkunft')) {
        params.fruehesteAnkunft = mitSekunden(this.form.fruehesteAnkunft);
        params.spaetesteAnkunft = mitSekunden(this.form.spaetesteAnkunft);
        params.restriktionenHinRollover = +this.form.restriktionenHinRollover;
      }
      if (keys.includes('releasefrist') && this.form.releasefrist !== null) {
        params.releasefrist = this.form.releasefrist.map(item => item.value);
      }
      return params;
    },
    formatParamsReiseterminValues() {
      if (this.editFields?.length > 0 && this.reiseterminEditData?.length > 0) {
        const params = this.reiseterminEditData.reduce((acc, curr) => {
          acc[curr.startdatum] = {
            istZusatztermin: this.keysFromEditFields.includes('istZusatztermin')
              ? this.form.istZusatztermin
              : curr.istZusatztermin,
            thLangstrecke: this.keysFromEditFields.includes('thLangstrecke')
              ? this.form.thLangstrecke
              : curr.thLangstrecke,
            thInlandsflug: this.keysFromEditFields.includes('thInlandsflug')
              ? this.form.thInlandsflug
              : curr.thInlandsflug,
            istInKlaerung: this.keysFromEditFields.includes('istInKlaerung')
              ? this.form.istInKlaerung === true
              : curr.istInKlaerung,
          };
          return acc;
        }, {});
        return params;
      } else return null;
    },
    onShow() {
      // Gemeinsame weitere Partner aller Termine werden vorbelegt, bei Abweichungen bleibt das Feld leer
      const partnerJeTermin = this.reiseterminEditData.map(
        rt => rt.metadata?.weiterePartner?.map(p => p.countryManagerKuerzel) ?? []
      );
      const [erste = []] = partnerJeTermin;
      this.form.weiterePartner = partnerJeTermin.every(partner => arraysEqualUnordered(partner, erste))
        ? [...erste]
        : [];
      if (this.preexistingFormData != null) {
        this.form = { ...this.preexistingFormData };
      }
      if (this.changedFields) {
        this.editFields = this.changedFields.filter(changedField =>
          this.fieldEditOptions.some(fieldOption => fieldOption.key === changedField)
        );
      }
    },
    async handleSubmit(hide) {
      const reisekuerzel = this.reisekuerzelToEdit;

      // Bei einem Fehler bleibt das Modal offen, das Overlay wird in jedem Fall beendet
      try {
        // wenn es Felder zu bearbeiten gibt, wo die Metadaten bearbeitet werden müssen
        if (this.selectedFieldOptions.some(field => !field.reiseterminValues)) {
          const formattedParams = this.formatParams();
          if (Object.values(formattedParams)?.length > 0) {
            this.isLoading = true;
            const res = await this.$store.dispatch(EDIT_REISETERMIN_METADATA_MULTIPLE, {
              formattedParams,
              reisekuerzel,
            });
            this.toast('Erfolgreich bearbeitet.');
            this.$emit('reiseterminMetadataBearbeitet', res.data.result.value);
          }
        }
        if (this.selectedFieldOptions.some(field => field.reiseterminValues)) {
          const formattedParams = this.formatParamsReiseterminValues();
          if (Object.values(formattedParams).length > 0) {
            this.isLoading = true;
            const res = await this.$store.dispatch(BULK_EDIT_REISETERMIN_VALUES, {
              formattedParams,
              reisekuerzel,
            });
            this.toast('Erfolgreich bearbeitet.');
            this.$emit('reiseterminValuesBearbeitet', res.data.result);
          }
        }
        hide();
      } finally {
        this.isLoading = false;
      }
    },
    onHide() {
      this.form = {
        overnightOutbound: null,
        overnightInbound: null,
        ziellandAbflughaefenIataCodes: null,
        ziellandZielflughaefenIataCodes: null,
        ziellandAbflughafenPrio: null,
        ziellandZielflughafenPrio: null,
        hotelstartVorLandung: null,
        rueckflugNachHotelende: null,
        vornachtMoeglich: false,
        kalkPax: null,

        minPax: null,
        maxPax: null,
        durchfuehrbareMinPax: null,
        skrFlugangebot: null,
        transferszenarioHin: null,
        transferszenarioRueck: null,
        hotelnaechte: null,
        fruehesterAbflug: null,
        spaetesterAbflug: null,
        fruehesteAnkunft: null,
        spaetesteAnkunft: null,
        releasefrist: null,
        istZusatztermin: null,
        istInKlaerung: null,
        thLangstrecke: null,
        thInlandsflug: null,
        einkaufspreisVornachtDzProPerson: null,
        erwarteteTermindurchfuehrungsquote: null,
        restriktionenHinRollover: null,
        restriktionenRueckRollover: null,
        vorverlaengerung: null,
        hinflugMaxWartezeit: null,
        hinflugMaxAnzahlTransfergruppen: null,
        rueckflugMaxWartezeit: null,
        rueckflugMaxAnzahlTransfergruppen: null,
        weiterePartner: [],
      };
      this.editFields = [];
    },
    onAddReleasefrist() {
      const length = this.form.releasefrist?.length;
      if (!this.form.releasefrist) {
        this.form.releasefrist = [{ value: 0, id: 1 }];
        return;
      }
      this.form.releasefrist = [...this.form.releasefrist, { value: 0, id: length + 1 }];
    },
    onRemoveReleasefrist() {
      const length = this.form.releasefrist.length;
      this.form.releasefrist.pop();
      // Nach dem Entfernen der letzten Frist wird der Ausgangszustand wiederhergestellt
      if (this.form.releasefrist.length === 0) {
        this.form.releasefrist = null;
      }
    },
  },
};
</script>
<style scoped>
.hinweis-ueberschreiben {
  color: var(--danger);
  font-size: 14px;
  white-space: nowrap;
}

.weitere-partner-feld {
  grid-column: span 2;
  justify-self: start;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
</style>
